export class RightOutDTO {
  name!: string;
  description?: string;
}
